/*
 * Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { SimpliCityAdminSDK } from "@simplicitycms/simplicity-admin-js-sdk";
import { uploadFile } from "./azure-storage.js";
import { FILE_TYPES_BY_EXTENSION } from "../file-types.js";
import { isArray } from "utils/empty-exists.js";
// import { generateGuid } from "utils/empty-exists.js";
import { Logger, greenBright } from "cms/utils/log/logger.js";

/**
 * Replaces characters in the file name.
 * @param {File} file
 */
export const getAcceptableFilename = (file) => {
    let fileName = file?.name?.replace(/ /g,"_");
    // fileName = `${generateGuid()}_${fileName}`;
    Logger.debug(`renaming file from [${file.name}] to [${fileName}]`);
    return fileName;
};
/**
 * Upload the given files.
 * @param {string} token authentication token
 * @param {File[]} acceptedFiles an array of file objects that were accepted
 * @param {string} formResponseId the id of the form response these files are attached to
 * @param {string} organization the organization associated with this website
 */
export const processFiles = async (token, acceptedFiles, formResponseId, organization) => {

    const uploaded_files = [];

    for (const file of acceptedFiles) {

        Logger.debug(`start upload file ${file.name}`);
        Logger.debug(`get sas token`);
        
        const sas_response = await SimpliCityAdminSDK.file.getToken(token);
        const {
            sas,
            storageAccountName,
            storageAccount,
            containerName,
            fileUrlBase
        } = sas_response;
        Logger.debug("SAS TOKEN RESPONSE", sas_response);

        // *** UPLOAD TO AZURE STORAGE ***
        Logger.debug(`Uploading file: ${file.name}`);
        // setUploadStatus({ status: "INCOMPLETE", message: "The upload has begun." })
        
        const uploadResult = await uploadFile(storageAccount, containerName, file, sas);
        // const uploadResult = { status: "success" };
        
        // setUploadStatus(uploadResult)
        if (uploadResult.status === "ERROR") {
            Logger.debug(`Failed - Uploading to storage for file: ${file.name}`);
            Logger.error(uploadResult);
            throw Error(uploadResult.message);
        } else {
            Logger.debug(`Succeeded - Uploading to storage for file: ${file.name}`);
            const encodedFilename = encodeURIComponent(file.name);
            const storage_url = `${storageAccount}/${containerName}/${encodedFilename}`;
            // const storage_url = `${fileUrlBase}/${containerName}/${encodedFilename}`;
            const url = `${fileUrlBase}/${encodedFilename}`;
            const ext = file.name.split(".").pop();
            const payload = {
                title: `File - ${file.name}`,
                reference: formResponseId,
                file_name: file.name,
                file_ext: ext,
                file_type: file.type,
                file_size: file.size,
                storage_url: storage_url,
                storage_account: storageAccountName,
                storage_container: containerName,
                storage_filepath: encodedFilename,
                url: url,
            };

            // Add record to the database
            Logger.debug(`Calling API for file: ${file.name}`, payload);
            let response;
            try {
                response = await SimpliCityAdminSDK.file.create(
                    token,
                    organization,
                    formResponseId, // TODO: will deprecate in favour of reference
                    payload
                );
                Logger.info(`File API Response: ${JSON.stringify(response)}`);
                uploaded_files.push(response);

            } catch (err) {
                Logger.debug(`Failed to upload file ${file.name}`);
                uploaded_files.push( { status: "error" } );
                // need to set an error
                Logger.error(err);
                throw err;
            }
        }
    }
    return uploaded_files;
};

export const getAcceptableFiles = (isLimited, acceptableExtensions) => {
    // default -> does not limit types
    let acceptableTypes = undefined;
    if (isLimited) {
        acceptableTypes = filterAcceptableFiles(acceptableExtensions);
    }
    return acceptableTypes;
};

export const filterAcceptableFiles = (fileTypes) => {
    let acceptedTypes = {};
    if (!isArray(fileTypes)) {
        Logger.warn(greenBright(`No acceptable files found. fileTypes was: ${fileTypes}`));
        // console.warn(`No acceptable files found. fileTypes was: ${fileTypes}`);
        fileTypes = [];
    }
    fileTypes?.map((fileExtension) => (
        acceptedTypes = {
            ...acceptedTypes,
            ...FILE_TYPES_BY_EXTENSION[fileExtension]
        }
    ));
    return acceptedTypes;
};


